const ENLARGE_KEY = 'word_enlarge_mode'
const EYE_CARE_KEY = 'word_eye_care_mode'
const ENLARGE_CLASS = 'enlarge-mode'
const EYE_CARE_CLASS = 'eye-care-mode'

function readFlag (key) {
  try {
    return localStorage.getItem(key) === '1'
  } catch (e) {
    return false
  }
}

function writeFlag (key, enabled) {
  try {
    localStorage.setItem(key, enabled ? '1' : '0')
  } catch (e) { /* ignore */ }
}

function toggleClass (className, enabled) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  if (enabled) root.classList.add(className)
  else root.classList.remove(className)
}

export function isEnlargeMode () {
  return readFlag(ENLARGE_KEY)
}

export function setEnlargeMode (enabled) {
  writeFlag(ENLARGE_KEY, enabled)
  toggleClass(ENLARGE_CLASS, enabled)
  return enabled
}

export function isEyeCareMode () {
  return readFlag(EYE_CARE_KEY)
}

export function setEyeCareMode (enabled) {
  writeFlag(EYE_CARE_KEY, enabled)
  toggleClass(EYE_CARE_CLASS, enabled)
  return enabled
}

export function initDisplayPrefs () {
  toggleClass(ENLARGE_CLASS, isEnlargeMode())
  toggleClass(EYE_CARE_CLASS, isEyeCareMode())
}

export default {
  isEnlargeMode,
  setEnlargeMode,
  isEyeCareMode,
  setEyeCareMode,
  init: initDisplayPrefs
}



// WEBPACK FOOTER //
// ./src/utils/displayPrefs.js